import { common } from '@rchh/lowcode-engine';
import enUS from './en-US.json';
import zhCN from './zh-CN.json';

type IntlParams = Record<string, string | number>;

const fallbackMessages: Record<string, string> = zhCN;

const injectParams = (message: string, params?: IntlParams) =>
  Object.entries(params || {}).reduce(
    (result, [key, value]) => result.replace(new RegExp(`\\{\\s*${key}\\s*\\}`, 'g'), String(value)),
    message,
  );

const { intl } = common?.utils?.createIntl?.({
  'en-US': enUS,
  'zh-CN': zhCN,
}) || {
  intl: (id: string, params?: IntlParams) => {
    return injectParams(fallbackMessages[id], params);
  }
};

export { intl };
